/* =================== FAQ ACCORDION — Perguntas Frequentes (jQuery) =================== */
$(function () {
  if (!$('.faq-pergunta').length) return;

  $('.faq-pergunta').on('click', function () {
    $(this).next('.faq-resposta').slideToggle();
    $(this).parent('.faq').toggleClass('open');
  });
});
